import { Component, EventEmitter, inject, Input, Output, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface GameServer {
  name: string;
  ip: string;
  port: number;
  players: string;
  maxPlayers: number;
  currentPlayers: number;
  ping: number;
  location: string;
  password?: string;
  map?: string;
  mod?: string;
  hostedBy: string;
  mapImage: string;
  description: string;
  nextMap: string;
}

@Component({
  selector: 'app-server-browser-modal',
  imports: [CommonModule],
  templateUrl: './server-browser-modal.html',
  styleUrl: './server-browser-modal.scss',
})
export class ServerBrowserModal {
  @Input()
  public gameTitle: string = 'Game';

  @Output()
  public selectServer = new EventEmitter<GameServer>();

  public servers: GameServer[] = [
    { 
      name: 'Rival Forge US East #1', 
      ip: '198.51.100.12', 
      port: 27910, 
      players: '5/16', 
      maxPlayers: 16,
      currentPlayers: 5,
      ping: 32, 
      location: 'Virginia, US', 
      map: 'q2dm1', 
      mod: 'Action',
      hostedBy: 'RivalForge_Host',
      mapImage: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=400&h=220&q=80',
      description: 'Official Rival Forge US East Server. Experience low latency and classic Action Quake II gameplay. Symmetrical layout and custom modifiers enabled.',
      nextMap: 'q2dm3'
    },
    { 
      name: 'Rival Forge EU West #1', 
      ip: '203.0.113.85', 
      port: 27910, 
      players: '12/16', 
      maxPlayers: 16,
      currentPlayers: 12,
      ping: 76, 
      location: 'Frankfurt, DE', 
      map: 'q2dm3', 
      mod: 'CTF',
      hostedBy: 'An_Olde_Fart',
      mapImage: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=400&h=220&q=80',
      description: 'OLDE FARTS CONQUEST SMALL. Standard Capture The Flag game with classic physics, moderate player XP boosts, and friendly community players.',
      nextMap: 'q2dm8'
    },
    { 
      name: 'Rival Forge Asia East #1', 
      ip: '192.0.2.144', 
      port: 27910, 
      players: '0/16', 
      maxPlayers: 16,
      currentPlayers: 0,
      ping: 240, 
      location: 'Tokyo, JP', 
      map: 'q2dm8', 
      mod: 'Vanilla',
      hostedBy: 'Tokyo_Gamer',
      mapImage: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?auto=format&fit=crop&w=400&h=220&q=80',
      description: 'Vanilla deathmatch server. Pure gameplay, no modifications, classic weapons spawning, and default respawn timers.',
      nextMap: 'q2dm1'
    },
    { 
      name: 'Custom LAN Server', 
      ip: '127.0.0.1', 
      port: 27910, 
      players: '1/8', 
      maxPlayers: 8,
      currentPlayers: 1,
      ping: 1, 
      location: 'Localhost', 
      map: 'base1', 
      mod: 'Coop',
      hostedBy: 'Local_Host',
      mapImage: 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?auto=format&fit=crop&w=400&h=220&q=80',
      description: 'Local development and cooperation server. Running base campaign maps with custom local modifiers.',
      nextMap: 'base2'
    }
  ];

  public activeServer = signal<GameServer>(this.servers[0]);

  public queryProgress = signal<string>('100% Complete');

  public averagePing = computed(() => {
    if (this.servers.length === 0) return 0;
    const sum = this.servers.reduce((acc, s) => acc + s.ping, 0);
    return Math.round(sum / this.servers.length);
  });

  public selectActive(server: GameServer) {
    this.activeServer.set(server);
  }

  public onSelect(server: GameServer) {
    this.selectServer.emit(server);
  }
}
